import MultiSelectInput from '@repo/ui/multiselect-input'
import { useQuery } from '@tanstack/react-query'

import { getCountries } from '../../../api/countries/get-countries'
import { getPeriods } from '../../../api/periods/get-periods'
import { PaymentConditionFilter } from '../../../lib/types/models/payment-condition/payment-condition-filter'

interface Props {
  filter?: PaymentConditionFilter
  onFilterChange: (filter: PaymentConditionFilter) => void
}

export function PaymentConditionFilters({ filter, onFilterChange }: Props) {
  function setFilter<K extends keyof PaymentConditionFilter>(
    key: K,
    value: PaymentConditionFilter[K]
  ) {
    onFilterChange({ ...filter, [key]: value })
  }

  const { data: periods } = useQuery({
    queryKey: ['periods'],
    queryFn: () => getPeriods({ version: 'BASIC' })
  })

  const { data: countries } = useQuery({
    queryKey: ['countries'],
    queryFn: () => getCountries()
  })

  return (
    <div className={'flex flex-col gap-3'}>
      <div />
      <MultiSelectInput
        searchable
        label={'Périodes'}
        variant={'primary'}
        options={periods?.data.map((period) => ({ label: period.name, value: period.id })) ?? []}
        selectedOptions={filter?.periods?.map((period) => ({
          label: periods?.data?.find((p) => p.id === period)?.name ?? '',
          value: period
        }))}
        onChange={(periods) => setFilter('periods', periods)}
      />
      <MultiSelectInput
        searchable
        label={'Pays'}
        variant={'primary'}
        options={countries?.data.map((country) => ({ label: country.name, value: country.id }))}
        selectedOptions={filter?.countries?.map((country) => ({
          label: countries?.data?.find((c) => c.id === country)?.name ?? '',
          value: country
        }))}
        onChange={(countries) => setFilter('countries', countries)}
      />
    </div>
  )
}
